import React from 'react';
import './ContactTable.css';

function ContactTable({ contacts, onViewContact, onViewTasks }) {
  // Traffic light logic
  const getTrafficLightIcon = (contact) => {
    const totalTasks = parseInt(contact.total_tasks) || 0;
    const doneTasks = parseInt(contact.done_tasks) || 0;
    
    if (totalTasks === 0) return '/traffic/red-1.svg';
    if (doneTasks === 0) return '/traffic/red-1.svg';
    if (doneTasks === totalTasks) return '/traffic/green-1.svg';
    return '/traffic/yellow-1.svg';
  };

  if (contacts.length === 0) {
    return (
      <div className="contacts-list">
        <div className="no-contacts">
          <p>No contacts yet. Add your first contact to get started!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contacts-list">
      <div className="contacts-table">
        <div className="table-header">
          <div>NAME</div>
          <div>DATE/TIME</div>
          <div>EMAIL</div>
          <div>PHONE</div>
          <div>LOCATION</div>
          <div>PROGRESS</div>
          <div>ACTIONS</div>
        </div>
        
        {contacts.map(contact => (
          <div key={contact.id} className="table-row">
            <div className="name">
              <img 
                src={getTrafficLightIcon(contact)}
                alt="Status"
                className="traffic-light-inline"
              />
              {contact.first_name} {contact.last_name}
            </div>
            <div className="date-time">
              {contact.last_interaction_at 
                ? new Date(contact.last_interaction_at).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit'
                  }) + ' - ' + new Date(contact.last_interaction_at).toLocaleTimeString('en-GB', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                  })
                : '-'
              }
            </div>
            <div className="email">{contact.email || '-'}</div>
            <div className="phone">{contact.phone || '-'}</div>
            <div className="location">
              {contact.city && contact.country ? `${contact.city}, ${contact.country}` : '-'}
            </div>
            <div className="tasks">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{
                    width: contact.total_tasks > 0 
                      ? `${(contact.done_tasks / contact.total_tasks) * 100}%` 
                      : '0%'
                  }}
                ></div>
              </div>
              <div className="progress-text">
                {contact.done_tasks || 0}/{contact.total_tasks || 0}
              </div>
            </div>
            <div className="actions">
              <button 
                className="action-btn"
                onClick={() => onViewContact(contact)}
              >
                View
              </button>
              <button 
                className="action-btn tasks-btn"
                onClick={() => onViewTasks(contact)}
              >
                Tasks
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactTable;

